import Sidebar from './Sidebar';
import React, { useState, useImperativeHandle, useEffect, useRef, forwardRef } from 'react';
import { FaBagShopping, FaLinkedin } from 'react-icons/fa6';
import logo from "../images/Logo.png"
import logoBlue from "../images/12.png";
import { Helmet, HelmetProvider, HelmetData } from 'react-helmet-async';


import {
    FaFacebook,
    FaTwitter,
    FaInstagram,
    FaLinkedinIn,
    FaHome,
    FaInfoCircle,
    FaWrench,
    FaPhoneAlt,
} from 'react-icons/fa';

const Header = forwardRef((props, ref) => {
    const cartRef = useRef();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [cartItemCount, setCartItemCount] = useState(0);
    const [cartItemPrice, setCartItemPrice] = useState(0);
    const transparent = props.transparent;
    const pageName = props.pageName;
    const color = props.color;
    useImperativeHandle(ref, () => ({
        refreshCart: () => {
            updateCartItems();
            cartRef.current.refreshCart();
        }
    }));
    useEffect(() => {
        updateCartItems();
    }, []);
    const toggleSidebar = () => {
        setIsSidebarOpen(prevState => !prevState);
    };
    const updateCartItems = () => {
        const cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
        setCartItemCount(cartItems.length);
        calculateTotal(cartItems);
    };
    const calculateTotal = (items) => {
        const total = items.reduce((acc, item) => acc + item.price * item.quantity, 0);
        setCartItemPrice(total);
    };
    return (

        <div>
            <Helmet>
                <title>{pageName} - Iram Khoker</title>
            </Helmet>
            <Sidebar color={color} pageName={pageName} />
            {/* Navbar */}
            <div className="desktop-nav absolute w-full bg-[transparent] z-20">
                <nav className={`px-16 mx-auto h-14 pt-24 py-20 flex items-center justify-between uppercase tracking-widest font-bold text-sm select-none`}>
                    <div className="flex items-center gap-8">
                        {/* Home icon - using inline SVG */}
                        <a href="/" aria-label="Home" >
                            <img
                                src={color == "blue" ? logoBlue : logo}
                                alt="Logo"
                                className="mb-3 w-[90px] object-contain"
                            />
                        </a>
                        {pageName !== "Home" && <a href="/Services" className={`text-lg transition delay-50 duration-300 ease-in-out text-${color == "blue" ? "[#80a2a5]" : "white"}  pb-2 border-transparent border-b-2 ${color == "blue" ? " hover:border-[#80a2a5]" : "hover:border-white"} font-normal poppins ${pageName == "Services" ? "selected-link" : ""}`}>
                            VIP SERVICES
                        </a>
                        }
                        {pageName !== "Home" &&
                            <a href="/About" className={`text-lg transition delay-50 duration-300 ease-in-out text-${color == "blue" ? "[#80a2a5]" : "white"}  pb-2 border-transparent border-b-2 ${color == "blue" ? " hover:border-[#80a2a5]" : "hover:border-white"} font-normal poppins ${pageName == "About" ? "selected-link" : ""}`}>
                                ABOUT
                            </a>
                        }
                        {pageName !== "Home" &&
                            <a href="/Contact" className={`text-lg transition delay-50 duration-300 ease-in-out text-${color == "blue" ? "[#80a2a5]" : "white"}  pb-2 border-transparent border-b-2 ${color == "blue" ? " hover:border-[#80a2a5]" : "hover:border-white"} font-normal poppins ${pageName == "Contact" ? "selected-link" : ""}`}>
                                CONTACT US
                            </a>
                        }
                        {pageName !== "Home" &&
                            <a href="/Rewire" className={`px-4 rounded-full text-md transition delay-50 duration-300 ease-in-out text-${color == "blue" ? "white" : "[#80a2a5]"}  py-1 ${color == "blue" ? "bg-[#80a2a5]" : "bg-white"} ${color == "blue" ? "border-[#80a2a5]" : "border-white"} border-2 ${color == "blue" ? " hover:border-[#80a2a5] hover:text-[#80a2a5]" : "hover:border-white hover:text-white"} hover:bg-transparent font-semibold mb-2 poppins ${pageName == "Contact" ? "selected-link" : ""}`}>
                                rewire now
                            </a>
                        }
                    </div>
                    <div className={`flex space-x-6 text-${color == "blue" ? "[#80a2a5]" : "white"} mt-0`}>
                        {pageName == "Home" &&
                            <a href="/About" className={`text-lg transition delay-50 duration-300 ease-in-out text-${color == "blue" ? "[#80a2a5]" : "white"}  pb-2 border-transparent border-b-2 ${color == "blue" ? " hover:border-[#80a2a5]" : "hover:border-white"} font-normal poppins ${pageName == "About" ? "selected-link" : ""}`}>
                                ABOUT
                            </a>
                        }
                        {pageName == "Home" &&
                            <a href="/Rewire" className={`px-4 rounded-full text-md transition delay-50 duration-300 ease-in-out text-${color == "blue" ? "white" : "[#80a2a5]"}  py-1 ${color == "blue" ? "bg-[#80a2a5]" : "bg-white"} ${color == "blue" ? "border-[#80a2a5]" : "border-white"} border-2 ${color == "blue" ? " hover:border-[#80a2a5] hover:text-[#80a2a5]" : "hover:border-white hover:text-white"} hover:bg-transparent font-semibold mb-2 poppins ${pageName == "Contact" ? "selected-link" : ""}`}>
                                rewire now
                            </a>
                        }
                        <a href="https://www.facebook.com/share/17obGDuRuX" target='_blank' aria-label="Facebook" className='text-3xl ' >
                            <FaFacebook />
                        </a>
                        <a href="https://www.instagram.com/iramkhokher.lifecoach" target='_blank' aria-label="Instagram" className='text-3xl '>
                            <FaInstagram />
                        </a>
                        <a href=" https://www.linkedin.com/in/iram-khokher-coach-for-high-achieviers" aria-label="LinkedIn" target='_blank' className='text-3xl '>
                            <FaLinkedin />
                        </a>
                    </div>
                </nav>
            </div>
        </div>
    )
});
export default Header;